function extractElementFromSlot(slot, elementTag) {
  if (!slot) {
    return typeof elementTag === 'string' ? undefined : [];
  }
  const elements = slot.assignedElements({ flatten: true });
  const filterFunction = (eTag) => {
    const ETAG = eTag.toUpperCase();
    const results = elements.filter((e) => e.tagName === ETAG);
    if (results.length > 1) {
      console.warn(`The element has more than one ${eTag} slotted. ` +
        `This behaviour is not supported and only one of them will be used`);
    }
    return results[0];
  };
  if (typeof elementTag === 'string') {
    return filterFunction(elementTag);
  }
  else {
    return elementTag.map(filterFunction);
  }
}
function extractElementsFromSlot(slot, elementTag) {
  if (!slot) {
    return typeof elementTag === 'string' ? [] : elementTag.map(() => []);
  }
  const elements = slot.assignedElements({ flatten: true });
  const filterFunction = (eTag) => {
    const ETAG = eTag.toUpperCase();
    return elements.filter((e) => e.tagName === ETAG);
  };
  if (typeof elementTag === 'string') {
    return filterFunction(elementTag);
  }
  else {
    return elementTag.map(filterFunction);
  }
}

export { extractElementsFromSlot as a, extractElementFromSlot as e };
